import React from 'react';
import styled from 'styled-components';
import StackSkolvovo from './StackSkolkovo';
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const Container = styled.div`
    border-radius: 1rem;
    padding-block-end: 2rem;
    padding-block-start: 2rem;
    background-color: #121212;
    background-image: url(${process.env.PUBLIC_URL}/img/SkolkovoVectorExp.svg);
    background-repeat: no-repeat;
    background-position: 88% 30%;
    background-size: 90rem;
    opacity: 0;
    transform: translateY(2.5rem);
    transition: opacity 0.7s cubic-bezier(0.23, 1, 0.32, 1),
        transform 0.7s cubic-bezier(0.23, 1, 0.32, 1);

    &.visible {
        opacity: 1;
        transform: translateY(0);
    }

    h1 {
        margin: 0 0 1rem 0;
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        font-size: clamp(1.6rem, 2.5vw + 0.5rem, 2.75rem);
        font-weight: 900;
    }

    h2 {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1.5vw + 0.3rem, 1.75rem);
        font-weight: 700;
    }

    p {
        padding: 0 calc(2rem + 1vw) 0 calc(2rem + 1vw);
        margin-top: 0;
        font-size: clamp(1rem, 1vw + 0.3rem, 1.3rem);
        text-transform: lowercase;
    }
`;

const ExpSkolkovo = () => {
    const [ref, isVisible] = useScrollAnimation();
    return (
        <Container ref={ref} className={isVisible ? 'visible' : ''}>
            <h1>SKOLKOVO</h1>
            <h2>fullstack developer (04.24 – 04.26)</h2>
            <p>
                built a react/typescript frontend for an ai sales avatar app
                with real-time webrtc/websocket communication and tokkio ui
                integration. migrated backend from flask to fastapi, refactored
                the react client post-mvp, and mentored developers in an agile
                team.
            </p>
            <StackSkolvovo />
        </Container>
    );
};

export default ExpSkolkovo;
